import { FC, PropsWithChildren } from 'react';

import { Root } from './LeftSide.styles';

export const LeftSide: FC<PropsWithChildren> = (props) => {
    const { children } = props;

    return <Root gridArea='leftSide'>{children}</Root>;
};

LeftSide.displayName = 'LeftSide';
